import { useEffect, useRef, useState } from "react";
import { sendMessageToGemini, isGeminiConfigured } from "../../../../../services/geminiService";

export function useAiAdvisorChat(report) {
  const [chatMessages, setChatMessages] = useState([
    {
      role: "ai",
      text: `Ciao! Sono il tuo AI Advisor specializzato in ambito assicurativo${
        report?.businessName ? ` per ${report.businessName}` : ""
      }. Come posso aiutarti con la tua analisi dei rischi?`,
    },
  ]);

  const [userInput, setUserInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const chatEndRef = useRef(null);
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatMessages]);

  const send = async () => {
    if (userInput.trim() === "") return;

    if (!isGeminiConfigured()) {
      setError("Gemini AI non è configurato correttamente. Verifica la API key nel file .env");
      return;
    }

    const userMessage = userInput.trim();
    const newMessages = [...chatMessages, { role: "user", text: userMessage }];

    setChatMessages(newMessages);
    setUserInput("");
    setIsLoading(true);
    setError(null);

    try {
      const aiResponseText = await sendMessageToGemini(userMessage, chatMessages, report);
      setChatMessages([...newMessages, { role: "ai", text: aiResponseText }]);
    } catch (err) {
      setError(err?.message || "Si è verificato un errore. Riprova.");
      setChatMessages([
        ...newMessages,
        { role: "ai", text: "Mi dispiace, si è verificato un errore nella comunicazione. Per favore riprova." },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    chatMessages,
    userInput,
    setUserInput,
    isLoading,
    error,
    setError,
    send,
    chatEndRef,
  };
}